module.exports = __webpack_public_path__ + "media/images/icon_basic-956a36912d20a98a4569792debf3dc95.png";